module.exports = "<p>ventas-cliente works!</p>\r\n"